import {SETTINGS} from 'app/settings';
export interface ITimezoneConfig {
    timezoneIsAustralianRegion: boolean;
    timezoneIsChineseRegion: boolean;
    timezoneIsUSRegion: boolean;
}

export interface IContactData {
    phone: string;
    message?: string;
}

export class SubRegionMapper {
    public predicates: ITimezoneConfig;
    public regionMap: any;
    private timezones: any = SETTINGS.REGION_MAPS.timezones;
    private contactData: any = SETTINGS.REGION_MAPS.contactData;

    constructor(
        timezone: string
    ) {
        const timezoneIsAustralianRegion: boolean = this.isTimezoneAustralianRegion(timezone);
        const timezoneIsChineseRegion: boolean = this.isTimezoneChineseRegion(timezone);
        const timezoneIsUSRegion: boolean = this.isTimezoneUSRegion(timezone);

        this.predicates = {
            timezoneIsAustralianRegion,
            timezoneIsChineseRegion,
            timezoneIsUSRegion
        };

    }

    public getContactData(status: string): IContactData {
        const statusMessage = SETTINGS.REGION_MAPS.notificationKeys[status];
        const dataObj: IContactData = {phone: ''};
        if (this.predicates.timezoneIsAustralianRegion
                && !this.predicates.timezoneIsChineseRegion
                && !this.predicates.timezoneIsUSRegion) {
            dataObj.phone = this.contactData.australia.phone;
        } else if (this.predicates.timezoneIsChineseRegion
                && !this.predicates.timezoneIsAustralianRegion
                && !this.predicates.timezoneIsUSRegion) {
            dataObj.phone = this.contactData.china.phone;
        } else {
            dataObj.phone = status === 'seasonal-hold' ? this.contactData.us.tollFree : this.contactData.us.phone;
        }
        if (status === 'suspension-warning'
            || status === 'suspended'
            || status === 'seasonal-hold') {
            dataObj.message = statusMessage;
        }

        return dataObj;
    }

    private isTimezoneAustralianRegion(tz: string): boolean {
        let prefix;
        let zone;
        [prefix, zone] = tz.split('/');
        return (this.timezones.australian.indexOf(tz) > -1)
            || (prefix === 'Australia')
            || (prefix === 'Indian')
            || (prefix === 'Pacific' && this.timezones.exceptions.pacific.indexOf(zone) === -1);
    }

    private isTimezoneChineseRegion(tz: string): boolean {
        let prefix;
        let zone;
        [prefix, zone] = tz.split('/');
        return (this.timezones.chinese.indexOf(tz) > -1)
            || (prefix === 'Asia' && this.timezones.exceptions.asia.indexOf(zone) === -1);
    }

    private isTimezoneUSRegion(tz: string): boolean {
        let prefix;
        let zone;
        [prefix, zone] = tz.split('/');
        return (prefix !== 'Australia')
            && (prefix !== 'Indian')
            && (!this.isTimezoneAustralianRegion(tz))
            && (!this.isTimezoneChineseRegion(tz))
            && (this.timezones.australian.indexOf(tz) === -1)
            && (this.timezones.chinese.indexOf(tz) === -1);
    }
}



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./public/app/classes/application/application.sub.regionMap.ts